'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
exports.__esModule = true
exports.calcClassesv2 = exports.calcClasses = void 0

var _calcClasses = _interopRequireDefault(require('./calcClasses'))
exports.calcClasses = _calcClasses.default
var _calcClassesv = _interopRequireDefault(require('./calcClassesv2'))
exports.calcClassesv2 = _calcClassesv.default



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/react/index.js
// module id = 644
// module chunks = 0